const isPlainObject = require("lodash/isPlainObject");

function loopObjectOrArray(subject, fn, path) {
  const callFn = (data) =>
    fn.call(subject, {
      ...data,
      subject,
    });

  if (Array.isArray(subject))
    subject.forEach((value, index) =>
      callFn({
        key: index,
        value,
        path: {
          arr: path.arr.concat({
            key: index,
            type: "arrayIndex",
          }),
          str: `${path.str}[${index}]`,
        },
      })
    );
  else if (isPlainObject(subject))
    Object.entries(subject).forEach(([key, value]) => {
      const pathStrKey = key.replace(/\./g, "\\.");
      callFn({
        key,
        value,
        path: {
          arr: path.arr.concat({
            key,
            type: "objectProp",
          }),
          str: path.str ? `${path.str}.${pathStrKey}` : pathStrKey,
        },
      });
    });
}

function deepForEach(value, fn, path) {
  path = path || {
    arr: [],
    str: "",
  };

  loopObjectOrArray(
    value,
    function (data) {
      fn.call(this, data);

      deepForEach(data.value, fn, data.path);
    },
    path
  );
}

function deepFind(value, fn) {
  let returnVal;

  try {
    deepForEach(value, (data) => {
      let fnReturnVal = fn.call(this, data);

      if (fnReturnVal) {
        returnVal = data;
        throw "break";
      }
    });
  } finally {
    return returnVal;
  }
}

module.exports = {
  deepForEach,
  deepFind,
};
